import { Percent } from '@kodiak-finance/sdk-core'
import { StakingTokenType } from 'types/farms'

const STAKING_TOKEN_TYPE_LABELS: Record<StakingTokenType, string> = {
  [StakingTokenType.ISLAND]: 'Island',
  [StakingTokenType.V2]: 'V2',
  [StakingTokenType.CHARM]: 'Charm',
  [StakingTokenType.GENERIC]: 'Generic',
}

export type VaultProviderPoolType = 'Island' | 'V2' | 'Charm' | 'Generic'

export function formatPoolFeeTierPercent(feeTier?: number | null): string | null {
  if (typeof feeTier !== 'number' || Number.isNaN(feeTier)) return null
  return `${new Percent(feeTier, 1_000_000).toSignificant()}%`
}

export function normalizeVaultProvider(provider: string): StakingTokenType | null {
  const normalized = provider.toLowerCase()
  if (normalized === 'kodiak') return StakingTokenType.ISLAND
  if (normalized === StakingTokenType.V2) return StakingTokenType.V2
  if (normalized === StakingTokenType.CHARM) return StakingTokenType.CHARM
  if (normalized === StakingTokenType.GENERIC) return StakingTokenType.GENERIC
  return null
}

export function getVaultProviderPoolType(provider?: string | null): VaultProviderPoolType {
  if (!provider) return 'Generic'

  const normalized = normalizeVaultProvider(provider)

  switch (normalized) {
    case StakingTokenType.ISLAND:
      return 'Island'
    case StakingTokenType.V2:
      return 'V2'
    case StakingTokenType.CHARM:
      return 'Charm'
    default:
      return 'Generic'
  }
}

export function getVaultProviderLabel(provider?: string | null): string {
  if (!provider) return 'Pool'
  const normalized = normalizeVaultProvider(provider)
  return normalized ? STAKING_TOKEN_TYPE_LABELS[normalized] : provider
}
